(function () {
  'use strict';

  function money(cents, currencyCode) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents) / 100);
  }

  function uid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'hats-' + window.crypto.randomUUID();
    }
    return 'hats-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function initialize(root) {
    if (root.dataset.zugHatsReady === 'true') return;
    root.dataset.zugHatsReady = 'true';

    var form = document.getElementById(root.dataset.formId);
    var modal = document.getElementById(root.dataset.artworkModalId);
    var status = root.querySelector('[data-hats-status]');
    var submit = root.querySelector('[data-hats-submit]');
    var quantityError = root.querySelector('[data-hats-quantity-error]');
    var quantityButtons = Array.from(root.querySelectorAll('[data-hats-quantity]'));
    var customWrap = root.querySelector('[data-hats-custom-wrap]');
    var customInput = root.querySelector('[data-hats-custom-input]');
    var turnaroundButtons = Array.from(
      root.querySelectorAll('[data-zug-banner-choice-group="turnaround"] [data-value]')
    );
    var variantScript = root.querySelector('[data-hats-variants]');
    var fileInput = modal && modal.querySelector('[data-zug-banner-file-input]');
    var notes = modal && modal.querySelector('[data-zug-banner-order-notes]');
    var variants = [];
    var pricingConfig = null;
    var adjustmentVariants = null;
    var carrierVariant = null;
    var adding = false;
    var initializationFailed = false;

    try {
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    carrierVariant = variants
      .filter(function (variant) {
        return variant && variant.available && Number.isInteger(Number(variant.price)) &&
          Number(variant.price) > 0 && Number.isInteger(Number(variant.id));
      })
      .sort(function (left, right) {
        return Number(left.price) - Number(right.price);
      })[0] || null;

    var selectedTurnaround = turnaroundButtons.find(function (button) {
      return button.classList.contains('is-selected');
    }) || turnaroundButtons[0];

    var state = {
      quantity: 1,
      customMode: false,
      turnaround: selectedTurnaround ? selectedTurnaround.dataset.value : 'regular',
      turnaroundLabel: selectedTurnaround ? selectedTurnaround.dataset.label : '',
      turnaroundMultiplier: 1,
      artworkMode: '',
      artworkFilename: '',
      metrics: null,
      configUid: uid()
    };

    function setStatus(message, isError) {
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value;
    }

    function propertyInput(name) {
      return root.querySelector('[data-hats-property="' + name + '"]');
    }

    function setProperty(name, value, optional) {
      var input = propertyInput(name);
      if (!input) return;
      input.value = value == null ? '' : String(value);
      input.disabled = Boolean(optional && input.value === '');
    }

    function parseQuantity(value) {
      var text = String(value == null ? '' : value).trim();
      if (!/^\d+$/.test(text)) return NaN;
      var number = Number(text);
      return Number.isInteger(number) ? number : NaN;
    }

    function quantityMessage(quantity) {
      if (!Number.isFinite(quantity)) return 'Enter a whole-number quantity.';
      if (!pricingConfig) return '';
      if (quantity < pricingConfig.minimum_quantity) {
        return 'The minimum quantity is ' + pricingConfig.minimum_quantity + '.';
      }
      if (quantity > pricingConfig.maximum_quantity) {
        return 'The maximum quantity is ' + pricingConfig.maximum_quantity.toLocaleString() + '.';
      }
      return '';
    }

    function turnaroundMultiplier(value) {
      if (value === 'rush_3_5') return 1.2;
      if (value === 'rush_1_2') return 1.5;
      return 1;
    }

    function updateTimeline() {
      var minDays;
      var maxDays;
      if (state.turnaround === 'rush_3_5') {
        minDays = 3;
        maxDays = 5;
      } else if (state.turnaround === 'rush_1_2') {
        minDays = 1;
        maxDays = 2;
      } else {
        minDays = Number(root.dataset.productionMin);
        maxDays = Number(root.dataset.productionMax);
      }
      var rangeText = minDays === maxDays ? String(minDays) : minDays + '–' + maxDays;
      root.querySelectorAll('.ptl').forEach(function (timeline) {
        if (typeof timeline.ptlSetRange === 'function') timeline.ptlSetRange(minDays, maxDays);
        var visibleRange = timeline.querySelector('.ptl__days strong');
        if (visibleRange) visibleRange.textContent = rangeText;
      });
    }

    function render() {
      var recipeReady = root.dataset.recipeReady === 'true';
      var message = quantityMessage(state.quantity);
      var validQuantity = message === '' && pricingConfig;
      var metrics = null;

      if (validQuantity && window.ZugHatsPricing) {
        try {
          metrics = window.ZugHatsPricing.calculate(
            pricingConfig,
            state.quantity,
            state.turnaroundMultiplier
          );
        } catch (error) {
          console.error('[ZUG Hats] Pricing calculation failed.', error);
        }
      }
      state.metrics = metrics;

      quantityButtons.forEach(function (button) {
        var value = button.dataset.hatsQuantity;
        var selected = value === 'custom'
          ? state.customMode
          : !state.customMode && Number(value) === state.quantity;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      customWrap.hidden = !state.customMode;
      quantityError.textContent = message;

      setText('[data-hats-summary="quantity"]', Number.isFinite(state.quantity) ? String(state.quantity) : '—');
      setText(
        '[data-hats-summary="price-each"]',
        metrics ? money(metrics.unitPriceCents, root.dataset.currency) : 'Unavailable'
      );
      setText(
        '[data-hats-summary="total"]',
        metrics ? money(metrics.totalCents, root.dataset.currency) : 'Unavailable'
      );

      setProperty('Quantity', Number.isFinite(state.quantity) ? state.quantity : '');
      setProperty('Price per Hat', metrics ? money(metrics.unitPriceCents, root.dataset.currency) : '');
      setProperty('Turnaround', state.turnaroundLabel);
      setProperty('Artwork Method', state.artworkMode, true);
      setProperty('calc_line_uid', state.configUid);
      setProperty('_bundle_display_quantity', Number.isFinite(state.quantity) ? state.quantity : '');
      setProperty('_total_desired', metrics ? (metrics.totalCents / 100).toFixed(2) : '');
      setProperty('_hats_expected_total_cents', metrics ? metrics.totalCents : '');

      var ready = recipeReady && form && modal && pricingConfig && adjustmentVariants &&
        carrierVariant && metrics && !adding;
      submit.disabled = !ready;

      if (!recipeReady) {
        setStatus(root.dataset.recipeError, true);
      } else if (initializationFailed) {
        setStatus('Hat ordering is temporarily unavailable. Please contact us for help.', true);
      } else if (!window.ZugHatsPricing || !pricingConfig || !adjustmentVariants || !carrierVariant) {
        setStatus('Loading protected Hat pricing…');
      } else if (!metrics) {
        setStatus('This Hat configuration cannot be priced safely right now.', true);
      } else if (!adding) {
        setStatus('');
      }
      return ready;
    }

    function publicProperties() {
      var properties = {
        'Product Type': 'Custom Hats',
        'Quantity': String(state.quantity),
        'Price per Hat': money(state.metrics.unitPriceCents, root.dataset.currency),
        'Turnaround': state.turnaroundLabel,
        'Artwork Method': state.artworkMode,
        'calc_line_uid': state.configUid,
        '_pricing_engine': 'true',
        '_line_type': 'base',
        '_product_family': 'hats',
        '_bundle_quantity_locked': 'true',
        '_bundle_display_quantity': String(state.quantity),
        '_total_desired': (state.metrics.totalCents / 100).toFixed(2),
        '_hats_expected_total_cents': String(state.metrics.totalCents)
      };
      if (notes && notes.value.trim()) properties['Order Notes'] = notes.value.trim();
      return properties;
    }

    function responseError(response, fallback) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        throw new Error(payload.description || payload.message || fallback);
      });
    }

    function changeLine(lineKey, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      });
    }

    function rollbackBundle(configUid) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart rollback inspection failed.');
          return response.json();
        })
        .then(function (cart) {
          var matching = cart.items.filter(function (item) {
            return item.properties && item.properties.calc_line_uid === configUid;
          });
          return matching.reduce(function (promise, item) {
            return promise.then(function () { return changeLine(item.key, 0); });
          }, Promise.resolve());
        })
        .catch(function (error) {
          console.error('[ZUG Hats] Failed to roll back an incomplete configuration.', error);
        });
    }

    function verifyBundle(configUid, expectedTotalCents, requiresFile) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart verification failed.');
          return response.json();
        })
        .then(function (cart) {
          var matching = cart.items.filter(function (item) {
            return item.properties && item.properties.calc_line_uid === configUid;
          });
          var actualTotal = matching.reduce(function (sum, item) {
            return sum + Number(item.final_line_price || 0);
          }, 0);
          var base = matching.find(function (item) {
            return item.properties && item.properties._line_type === 'base';
          });
          var retainedFile = !requiresFile ||
            Boolean(base && base.properties && base.properties['Uploaded Artwork']);

          if (!matching.length || actualTotal !== expectedTotalCents || !retainedFile) {
            throw new Error('Shopify cart read-back did not match the configured Hat total or artwork.');
          }
          return cart;
        });
    }

    function refreshCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.setTimeout(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      }, 300);
    }

    function addUploadedLine(bundle) {
      var formData = new FormData(form);
      formData.set('id', String(carrierVariant.id));
      formData.set('quantity', String(state.quantity));

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (response) {
        if (!response.ok) return responseError(response, 'The configured Hats could not be added.');
        return response.json();
      }).then(function (line) {
        if (!line.properties || !line.properties['Uploaded Artwork']) {
          return changeLine(line.key, 0).then(function () {
            throw new Error('Shopify did not retain the uploaded Hat artwork.');
          });
        }
        if (!bundle.adjustmentItems.length) return line;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: bundle.adjustmentItems })
        }).then(function (response) {
          if (!response.ok) throw new Error('The exact Hat price adjustment could not be added.');
          return response.json();
        });
      });
    }

    function addUploadLaterLine(bundle) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: bundle.items })
      }).then(function (response) {
        if (!response.ok) return responseError(response, 'The configured Hats could not be added.');
        return response.json();
      });
    }

    function submitConfiguredHats() {
      if (!render() || !state.artworkMode) return;
      var bundle;
      var submittingUid = state.configUid;
      var expectedTotal = state.metrics.totalCents;
      var requiresFile = state.artworkMode === 'Upload Artwork';

      try {
        bundle = window.ZugBannerPricing.buildAdjustmentBundle({
          uid: submittingUid,
          totalCents: expectedTotal,
          basePriceCents: Number(carrierVariant.price),
          baseQuantity: state.quantity,
          baseVariantId: Number(carrierVariant.id),
          dollarVariantId: adjustmentVariants.dollar,
          centVariantId: adjustmentVariants.cent,
          baseProperties: publicProperties()
        });
      } catch (error) {
        console.error('[ZUG Hats] Exact-price bundle failed.', error);
        setStatus('This Hat configuration cannot be priced safely right now.', true);
        return;
      }

      adding = true;
      submit.setAttribute('aria-busy', 'true');
      setStatus('Adding your configured Hats to cart…');
      render();

      var addPromise = requiresFile ? addUploadedLine(bundle) : addUploadLaterLine(bundle);
      addPromise
        .then(function () {
          return verifyBundle(submittingUid, expectedTotal, requiresFile);
        })
        .then(function () {
          state.configUid = uid();
          state.artworkMode = '';
          state.artworkFilename = '';
          if (modal) modal.dispatchEvent(new CustomEvent('zug-banner:configuration-reset'));
          refreshCart();
        })
        .catch(function (error) {
          console.error('[ZUG Hats] Add to cart failed.', error);
          return rollbackBundle(submittingUid).then(function () {
            setStatus('Your configured Hats could not be added. Please try again or contact us.', true);
          });
        })
        .finally(function () {
          adding = false;
          submit.removeAttribute('aria-busy');
          render();
        });
    }

    quantityButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.dataset.hatsQuantity;
        if (value === 'custom') {
          state.customMode = true;
          state.quantity = parseQuantity(customInput.value);
          customWrap.hidden = false;
          customInput.focus();
        } else {
          state.customMode = false;
          state.quantity = Number(value);
          customInput.value = '';
        }
        render();
      });
    });

    customInput.addEventListener('keydown', function (event) {
      if (event.key === 'e' || event.key === 'E' || event.key === '+' ||
          event.key === '-' || event.key === '.' || event.key === ',') {
        event.preventDefault();
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        customInput.dispatchEvent(new Event('change'));
      }
    });
    customInput.addEventListener('input', function () {
      state.quantity = parseQuantity(customInput.value);
      render();
    });
    customInput.addEventListener('change', function () {
      var parsed = parseQuantity(customInput.value);
      if (pricingConfig && pricingConfig.preset_quantities.indexOf(parsed) !== -1) {
        state.customMode = false;
        state.quantity = parsed;
        customInput.value = '';
      }
      render();
    });

    submit.addEventListener('click', function (event) {
      if (!state.customMode) return;
      state.quantity = parseQuantity(customInput.value);
      if (!render()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        customInput.focus();
      }
    }, true);

    turnaroundButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.turnaround = button.dataset.value;
        state.turnaroundLabel = button.dataset.label;
        state.turnaroundMultiplier = turnaroundMultiplier(state.turnaround);
        turnaroundButtons.forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var turnaroundValue = root.querySelector('[data-zug-banner-turnaround-value]');
        if (turnaroundValue) turnaroundValue.textContent = state.turnaroundLabel;
        updateTimeline();
        render();
      });
    });

    if (modal) {
      modal.addEventListener('zug-banner:artwork-saved', function (event) {
        state.artworkMode = event.detail.mode === 'upload_artwork' ? 'Upload Artwork' : 'Upload Later';
        state.artworkFilename = event.detail.filename || '';
        render();
        submitConfiguredHats();
      });
    }

    Promise.all([
      fetch(root.dataset.pricingUrl, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Hats pricing JSON could not be loaded.');
        return response.json();
      }),
      fetch(root.dataset.variantMapUrl, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Exact-price carrier map could not be loaded.');
        return response.json();
      })
    ]).then(function (results) {
      window.ZugHatsPricing.validateConfig(results[0]);
      pricingConfig = results[0];
      var adjustment = results[1] && results[1].adjustment;
      adjustmentVariants = adjustment ? {
        dollar: Number(adjustment.dollar || adjustment.Dollar),
        cent: Number(adjustment.cent || adjustment.Cent)
      } : null;
      if (!adjustmentVariants ||
          !Number.isInteger(adjustmentVariants.dollar) ||
          !Number.isInteger(adjustmentVariants.cent)) {
        adjustmentVariants = null;
        throw new Error('Exact-price adjustment variants are not configured.');
      }
      initializationFailed = false;
      render();
    }).catch(function (error) {
      console.error('[ZUG Hats] Pricing initialization failed.', error);
      pricingConfig = null;
      adjustmentVariants = null;
      initializationFailed = true;
      render();
    });

    state.turnaroundMultiplier = turnaroundMultiplier(state.turnaround);
    render();
  }

  function initializeAll() {
    document.querySelectorAll('[data-zug-hats]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
